import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const prodConfig: ApplicationConfig = {
  apiUrl: 'https://api.skin-seoul.com',
  csAgentApiUrl: 'https://agent.skin-seoul.com',
  internalApiUrl: 'https://internal-api.skin-seoul.work',
  googleOAuthClientId: '639007308170-lcrsao9lgj3km159oo6uj2sjhs8tbrb8.apps.googleusercontent.com',
  apiKey: '55930ae6-9ed5-4e63-92a0-bd91fec26a45',
  stage: Stage.PROD,
  sheetId: '1ffxiNtrot1kCAcAVPov4mi2V7rmPRsVwd5wX5x9jv3U',
  wpAdminUrl: 'https://skin-seoul.com/wp-admin/',
  adminUrl: 'https://admin.skin-seoul.work',
  n8nWebhookBaseUrl: 'https://n8n.skin-seoul.work',
  slackTeamId: 'T06CKAJHMRU',
  logtoEndpoint: 'https://auth.skin-seoul.com',
  logtoAppId: 'hw76rxvuo4suurepc0yqh',
  logtoStaffOrganizationId: 'y8xsuiltg2bv',
};
